export const fetchAddress = postalCode =>
  fetch(`https://viacep.com.br/ws/${postalCode}/json/`)
    .then(response => response.json())
    .then(data => {
      return data;
    });
